import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  initialLoading: true,
  loading: false,
  hotelListData: [],
  error: false,
  locationSelectionErrorPopup: {
    isVisible: false,
    selectedHotel: null
  }
};

const hotelSelectorSlice = createSlice({
  name: 'hotelSelector',
  initialState,
  reducers: {
    hotelSelectorRequest: state => {
      state.loading = true;
      state.error = false;
    },
    hotelSelectorSuccess: (state, action) => {
      state.initialLoading = false;
      state.loading = false;
      state.hotelListData = action.payload.hotelListData;
    },
    hotelSelectorFailure: state => {
      state.initialLoading = false;
      state.loading = false;
      state.error = true;
    },
    setLocationSelectErrorPopup: (state, action) => {
      const { isVisible, selectedHotel } = action.payload;

      state.locationSelectionErrorPopup = {
        isVisible,
        selectedHotel: isVisible ? selectedHotel : null
      }
    },
  },
});

export const {hotelSelectorRequest, hotelSelectorSuccess, hotelSelectorFailure, setLocationSelectErrorPopup} = hotelSelectorSlice.actions;

export default hotelSelectorSlice.reducer;
